module.exports = __webpack_public_path__ + "img/theroom_dresser_thumb.5aef6d87.jpg";